import axios from 'axios';

const FETCH_COMPANIES_PATH = '/agent-selection/companies.json';

const getCompanies = async (query, callback) => {
  const url = `${FETCH_COMPANIES_PATH}?${query}`;
  return await axios.get(url)
    .then(response => response.data)
    .catch(error => {
      alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度接続してください')
    });
};

export default getCompanies;